import store from '@/store/'

export default (to, from, next) => {
	if (store.getters.apiToken) {
		next({ name: 'SongsList' })
	} else next()
}
